module.exports = __webpack_public_path__ + "static/1-48c9a595d3c181edc9c76039486ad53a.jpg";